var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.2348 22.9107C74.8516 20.1381 70.7022 22.2175 72.0853 25.6832C77.6179 38.8528 75.5432 54.1019 65.8611 63.8058C56.8707 72.8166 43.7307 76.9754 31.2824 73.5097C18.8341 70.044 9.15201 59.647 6.38571 47.1705C3.61941 34.694 7.76886 21.5244 18.1425 13.2067C30.5908 2.80968 48.5718 2.80968 61.7117 12.5136C64.478 14.593 67.2443 9.74106 64.478 8.35478C51.3381 -2.04228 32.6656 -2.73542 18.8341 6.27537C6.38571 13.8999 -1.22161 28.4558 0.161535 43.0117C1.54468 57.5675 10.5352 70.7372 24.3667 76.9754C38.1981 82.5205 54.1044 80.4411 65.8611 70.7372C79.6926 58.9538 83.8421 39.546 76.2348 22.9107Z",
    fill: "#AAB80E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5064 45.0909C31.9738 39.5458 25.7497 34.0007 20.2171 28.4556C17.4508 26.3762 13.9929 29.8419 16.7592 31.9213C22.9834 38.1595 29.8991 44.3978 36.1233 50.636C36.8149 51.3292 38.8896 51.3292 39.5812 50.636C50.6464 39.5458 61.7115 28.4556 72.7767 16.6723C74.1599 15.286 76.2346 13.8997 77.6178 12.5135C79.6925 10.434 76.2346 6.27522 74.1599 9.04777C62.4031 19.4448 51.3379 31.2282 40.2727 42.3184C39.5812 43.0115 38.198 44.3978 37.5064 45.0909Z",
    fill: "#AAB80E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.156f79d015ba63f8f92e833796372584.svg";
export { ForwardRef as ReactComponent };